import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie-player';

const LearnRealmTextAnimation = () => {
  const [animationData, setAnimationData] = useState();

  useEffect(() => {
    import('../../assets/lottie/LearnRealmText.json').then(setAnimationData);
  }, []);

  if (!animationData) return <div className="realm" />;
  return (
    <Lottie
      animationData={animationData}
      background="transparent"
      play
      speed={1}
      loop={false}
      className="text learn"
    />
  );
};

export default React.memo(LearnRealmTextAnimation);
